'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

var _dld_qrcode = require('./images/dld_qrcode.png');

var _dld_qrcode2 = _interopRequireDefault(_dld_qrcode);

var _icons = require('./images/icons.png');

var _icons2 = _interopRequireDefault(_icons);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

require('./App.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('url-search-params-polyfill');

var WebIndex = function (_React$Component) {
    _inherits(WebIndex, _React$Component);

    function WebIndex() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, WebIndex);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = WebIndex.__proto__ || Object.getPrototypeOf(WebIndex)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
            beianText: '京ICP备18016017号-8',
            companyEnName: 'Beijing Xiaowei Cloud Service Technology Co., Ltd.',
            downloadHost: 'https://download.dksnote.com',
            downloadFileName: '/windows/dksnote-setup.exe',
            macOSUrl: '',
            iOSUrl: '',
            helpRecent: [],
            showBeianText: false,
            showHelp: false,
            isWindow: true,
            contantUsQQWindows: '',
            contantUsQQMacos: '',
            contantUsEmail: 'service@xiaoweiyunfu.com'
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(WebIndex, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);

            var paramTN = search.get("tn");
            if (null != paramTN && paramTN.length > 0) {
                this.setState({ downloadFileName: '/dksnote_' + paramTN + '.exe' });
            }

            var src = search.get("src");
            if (src == 'macos') {
                this.setState({ isWindow: false });
            }

            var local = _Locale2["default"].GetInstance();
            document.title = local.getMessagebyId('www_title');

            var lang = local.getLang();
            if (lang === 'chs') {

                // this.GetRecentHelp();
                this.GetContantUs();

                this.setState({ showBeianText: true, downloadHost: 'https://download.dksnote.com' });
            }

            var country = 'us';
            if (lang == 'chs') {
                country = 'cn';
            } else if (lang == 'cht') {
                country = 'tw';
            } else if (lang == 'kor') {
                country = 'kr';
            }

            var macOSUrl = 'https://apps.apple.com/' + country + '/app/DkNote/id1570563588';
            var iOSUrl = 'https://apps.apple.com/' + country + '/app/DkNote/id1570563588?platform=iphone';
            this.setState({ macOSUrl: macOSUrl, iOSUrl: iOSUrl });
        }
    }, {
        key: 'GetRecentHelp',
        value: function GetRecentHelp() {

            var _this = this;

            fetch('/api/help/recent/8', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {
                var currenthelpRecent = _this.state.helpRecent;

                myJson.posts.forEach(function (element) {
                    currenthelpRecent.push(_react2["default"].createElement(
                        'div',
                        { className: 'helplink', key: element.url },
                        _react2["default"].createElement(
                            'a',
                            { href: element.url, className: 'top1' },
                            element.title
                        )
                    ));
                });

                _this.setState({ helpRecent: currenthelpRecent });
                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsQQWindows: myJson.vdata.qqwindow });
                _this.setState({ contantUsQQMacos: myJson.vdata.qqmacos });
                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'breakLine',
        value: function breakLine(text) {
            var br = _react2["default"].createElement('br');
            var regex = /(<br \/>)/g;
            return text.split(regex).map(function (line, index) {
                alert(text);
                return line.match(regex) ? _react2["default"].createElement('br', { key: "key_" + index }) : line;
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var local = _Locale2["default"].GetInstance();
            var titleText = local.getMessagebyId('www_title');
            var updateLog = ""; // local.getMessagebyId('update_log');
            var slogan_text1 = local.getMessagebyId('slogan_text1');
            var slogan_text2 = local.getMessagebyId('slogan_text2');
            var slogan_text3 = local.getMessagebyId('slogan_text3');
            var windows_button = local.getMessagebyId('windows_button');
            var mac_button = local.getMessagebyId('mac_button');
            var scan_download_phone = local.getMessagebyId('scan_download_phone');
            var content_title1 = local.getMessagebyId('content_title1');
            var content_text1 = local.getMessagebyId('content_text1');
            var content_title2 = local.getMessagebyId('content_title2');
            var content_text2 = local.getMessagebyId('content_text2');
            var content_title3 = local.getMessagebyId('content_title3');
            var content_text3 = local.getMessagebyId('content_text3');
            var content_title4 = local.getMessagebyId('content_title4');
            var content_text4 = local.getMessagebyId('content_text4');
            var content_title5 = local.getMessagebyId('content_title5');
            var content_text5 = local.getMessagebyId('content_text5');
            var content_title6 = local.getMessagebyId('content_title6');
            var content_text6 = local.getMessagebyId('content_text6');
            var support = local.getMessagebyId('support');
            var support_text1 = local.getMessagebyId('support_text1');
            var support_text2 = local.getMessagebyId('support_text2');
            var support_text3 = local.getMessagebyId('support_text3');
            var help = local.getMessagebyId('help');

            var image_1;
            var image_2;
            var image_3;
            var image_4;
            var image_5;
            var image_6;

            var lang = local.getLang();

            if (this.state.isWindow) {
                if (lang === 'chs') {
                    image_1 = require('./images/img_chs_win_1.png');
                    image_2 = require('./images/img_chs_win_2.png');
                    image_3 = require('./images/img_chs_win_3.png');
                    image_4 = require('./images/img_chs_win_4.png');
                    image_5 = require('./images/img_chs_win_5.png');
                    image_6 = require('./images/img_chs_win_6.png');
                } else if (lang === 'cht') {
                    image_1 = require('./images/img_cht_win_1.png');
                    image_2 = require('./images/img_cht_win_2.png');
                    image_3 = require('./images/img_cht_win_3.png');
                    image_4 = require('./images/img_cht_win_4.png');
                    image_5 = require('./images/img_cht_win_5.png');
                    image_6 = require('./images/img_cht_win_6.png');
                } else if (lang === 'kor') {
                    image_1 = require('./images/img_kor_win_1.png');
                    image_2 = require('./images/img_kor_win_2.png');
                    image_3 = require('./images/img_kor_win_3.png');
                    image_4 = require('./images/img_kor_win_4.png');
                    image_5 = require('./images/img_kor_win_5.png');
                    image_6 = require('./images/img_kor_win_6.png');
                } else if (lang === 'usa') {
                    image_1 = require('./images/img_usa_win_1.png');
                    image_2 = require('./images/img_usa_win_2.png');
                    image_3 = require('./images/img_usa_win_3.png');
                    image_4 = require('./images/img_usa_win_4.png');
                    image_5 = require('./images/img_usa_win_5.png');
                    image_6 = require('./images/img_usa_win_6.png');
                }
            } else {
                if (lang === 'chs') {
                    image_1 = require('./images/img_chs_1.png');
                    image_2 = require('./images/img_chs_2.png');
                    image_3 = require('./images/img_chs_3.png');
                    image_4 = require('./images/img_chs_4.png');
                    image_5 = require('./images/img_chs_5.png');
                    image_6 = require('./images/img_chs_6.png');
                } else if (lang === 'cht') {
                    image_1 = require('./images/img_cht_1.png');
                    image_2 = require('./images/img_cht_2.png');
                    image_3 = require('./images/img_cht_3.png');
                    image_4 = require('./images/img_cht_4.png');
                    image_5 = require('./images/img_cht_5.png');
                    image_6 = require('./images/img_cht_6.png');
                } else if (lang === 'kor') {
                    image_1 = require('./images/img_kor_1.png');
                    image_2 = require('./images/img_kor_2.png');
                    image_3 = require('./images/img_kor_3.png');
                    image_4 = require('./images/img_kor_4.png');
                    image_5 = require('./images/img_kor_5.png');
                    image_6 = require('./images/img_kor_6.png');
                } else if (lang === 'usa') {
                    image_1 = require('./images/img_usa_1.png');
                    image_2 = require('./images/img_usa_2.png');
                    image_3 = require('./images/img_usa_3.png');
                    image_4 = require('./images/img_usa_4.png');
                    image_5 = require('./images/img_usa_5.png');
                    image_6 = require('./images/img_usa_6.png');
                }
            }

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            titleText
                        ),
                        _react2["default"].createElement('div', { className: 'blank' }),
                        _react2["default"].createElement(
                            'a',
                            { className: 'right', href: 'https://help.dksnote.com/?page_id=177' },
                            updateLog
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'main' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'blockbkgnd' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'top' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top-text' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'text' },
                                        titleText
                                    )
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'center-text' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'line-text' },
                                        slogan_text1
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'line-text' },
                                        slogan_text2
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'line-text' },
                                        slogan_text3
                                    )
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'right' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top-text' },
                                    scan_download_phone
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'images' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'qrcode-bkgnd' },
                                        _react2["default"].createElement('img', { className: 'qrcode', src: _dld_qrcode2["default"], border: '0' })
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'download' },
                                        _react2["default"].createElement('a', { className: 'ios', href: this.state.iOSUrl }),
                                        _react2["default"].createElement('a', { className: 'android', href: this.state.downloadHost + "/android/app-release.apk" })
                                    )
                                )
                            )
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'center' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title1
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text1
                                    )
                                ),
                                _react2["default"].createElement('img', { className: 'image', src: image_1 })
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement('img', { className: 'image', src: image_2 }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title2
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text2
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title3
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text3
                                    )
                                ),
                                _react2["default"].createElement('img', { className: 'image', src: image_3 })
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement('img', { className: 'image', src: image_4 }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title4
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text4
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title5
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text5
                                    )
                                ),
                                _react2["default"].createElement('img', { className: 'image', src: image_5 })
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement('img', { className: 'image', src: image_6 }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title6
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text6
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    support
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    support_text1,
                                    this.state.contantUsEmail
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    support_text2,
                                    this.state.contantUsQQWindows,
                                    support_text3,
                                    this.state.contantUsQQMacos
                                )
                            ),
                            this.state.showHelp ? _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    help
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    this.state.helpRecent
                                )
                            ) : null
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            'Copyright \xA9 2023\xA0',
                            this.state.companyEnName,
                            '  ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicy' },
                                'Privacy Policy'
                            ),
                            ' / ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'eula' },
                                'EULA'
                            ),
                            this.state.showBeianText ? _react2["default"].createElement(
                                'div',
                                { className: 'beian' },
                                '\xA0\xA0\xA0\xA0\xA0\xA0 ',
                                _react2["default"].createElement(
                                    'a',
                                    { className: 'link', href: 'http://beian.miit.gov.cn/' },
                                    ' ',
                                    this.state.beianText
                                )
                            ) : null
                        )
                    )
                )
            );
        }
    }]);

    return WebIndex;
}(_react2["default"].Component);

exports["default"] = WebIndex;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./WebIndex.js
// module id = 262
// module chunks = 0